export const SEGMENT_LABELS = {
  active: "Active (last 7 days)",
  inactive: "Inactive 7–30d",
  inactive_14: "Inactive ≥14d",
  inactive_30: "Inactive ≥30d",
  free: "Free",
  premium: "Premium",
  expired: "Expired",
  trial_ending: "Trial ending ≤7d",
  sub_expiring: "Subscription expiring ≤3d",
  low_engagement: "Active but quiet",
};

export const CAMPAIGN_LABELS = {
  inactivity_7d: "Inactive 7 days",
  inactivity_14d: "Inactive 14 days",
  inactivity_30d: "Inactive 30 days",
  trial_ending_7d: "Trial ending 7 days",
  sub_expiring_3d: "Sub expiring 3 days",
  sub_expired: "Subscription expired",
  free_upsell: "Free user upsell",
  low_engagement_7d: "Low engagement 7 days",
  milestone_first_post: "Milestone: first post",
};

/** Filters for GET engagement/users/subscription */
export const SUBSCRIPTION_FILTERS = [
  "free",
  "premium",
  "expired",
  "trial_ending",
  "sub_expiring",
];

/** Filters for GET engagement/users/activity */
export const ACTIVITY_FILTERS = [
  "active",
  "inactive",
  "inactive_14",
  "inactive_30",
  "low_engagement",
];

export const SUBSCRIPTION_SEGMENT_KEYS = ["free", "premium", "expired"];

export const ENGAGEMENT_SEGMENT_KEYS = [
  "active",
  "inactive",
  "inactive_14",
  "inactive_30",
  "low_engagement",
];

export const ALERT_SEGMENT_KEYS = ["trial_ending", "sub_expiring"];

export const segmentLabel = (key) =>
  SEGMENT_LABELS[key] || key?.replace(/_/g, " ") || "Unknown";

export const campaignLabel = (slug, name) =>
  name || CAMPAIGN_LABELS[slug] || slug?.replace(/_/g, " ") || "Campaign";

export const getSegmentGroup = (filter) => {
  if (SUBSCRIPTION_FILTERS.includes(filter)) return "subscription";
  if (ACTIVITY_FILTERS.includes(filter)) return "activity";
  return null;
};

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return String(dateStr);

  const diffMs = Date.now() - date.getTime();
  const abs = Math.abs(diffMs);
  const mins = Math.floor(abs / 60000);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);

  const suffix = diffMs >= 0 ? "ago" : "from now";
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ${suffix}`;
  if (hours < 24) return `${hours}h ${suffix}`;
  if (days < 30) return `${days}d ${suffix}`;
  return date.toLocaleDateString();
};

export const STATUS_COLORS = {
  sent: "#3EBF8F",
  skipped: "#E6A700",
  failed: "#FF5757",
};

const isUuidLike = (value) =>
  typeof value === "string" &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value.trim()
  );

const joinName = (...parts) =>
  parts
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean)
    .join(" ");

/** Prefer decorated user fields: name → username → email. */
export const formatUserDisplay = (entity = {}, fallbackIndex) => {
  const user = entity.user || entity;
  const fullName = joinName(
    user.first_name || user.firstName,
    user.last_name || user.lastName
  );
  const title =
    fullName ||
    user.username ||
    user.user_name ||
    user.name ||
    user.full_name ||
    user.email ||
    (typeof fallbackIndex === "number"
      ? `User ${fallbackIndex + 1}`
      : "Unknown user");

  const subtitleCandidates = [
    user.email && title !== user.email ? user.email : null,
    user.username && title !== user.username ? `@${user.username}` : null,
    user.mobile_no,
  ].filter(Boolean);

  return {
    title: isUuidLike(title)
      ? user.email ||
        user.username ||
        (typeof fallbackIndex === "number"
          ? `User ${fallbackIndex + 1}`
          : "Unknown user")
      : title,
    subtitle: subtitleCandidates[0] || null,
  };
};

export const getLastNotification = (user = {}) =>
  user.last_notification || user.send || null;
